export const tailwindPrefix = 'readme-tailwind';
